import { toggleNav } from '../../js/main'
import '../../css/reset.css'
import '../../css/constants.css'
import '../../css/main.css'
import './vacuum-and-compressed-gas-systems.css'
import gsap from 'gsap'

gsap.set(document.querySelector('main'), {
    visibility: 'visible'
})
gsap.to(document.querySelector('.image-div'), {
    height: 'auto',
    duration: 0.5,
    ease: 'sine'
})
gsap.from(document.querySelectorAll('.list-item-div'), { 
    x: -10,
    autoAlpha: 0,
    ease: 'sine',
    stagger: 0.2,
    duration: 0.5
}, '>');


toggleNav()
// entry()
console.log('this is hydrocarbon recovery system page');